import { useQueryClient } from "@tanstack/react-query";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

import { Modal } from "../../components/modal";
import {
  getRoleContactFromForm,
  RoleForm,
  RoleFormValues,
} from "../../components/role-form";
import { useGetAssociationMembers } from "../../queries/association-member";
import { createRole } from "../../services/role";
import { useLocale } from "../../stores/locale";
import { navigateBack } from "../../utils/navigate-back";

const emptyFormValues: RoleFormValues = {
  name: "",
  description: "",
  externalDescription: "",
  contact: { email: "", phone: "" },
  assignedUserIds: [],
};

export function RoleCreate() {
  const navigate = useNavigate();
  const { currentLanguage } = useLocale();
  const queryClient = useQueryClient();
  const { data: members } = useGetAssociationMembers();
  const [loading, setLoading] = useState(false);
  const [hasError, setHasError] = useState(false);
  const [formValues, setFormValues] = useState<RoleFormValues>(emptyFormValues);

  const closeModal = () => {
    navigateBack(navigate, "/admin/role");
  };

  return (
    <Modal open onClose={closeModal}>
      <RoleForm
        editorKey={`new-${currentLanguage}`}
        hasError={hasError}
        loading={loading}
        members={members}
        values={formValues}
        onCancel={closeModal}
        onChange={setFormValues}
        onSubmit={() => {
          void (async () => {
            setLoading(true);
            setHasError(false);
            try {
              await createRole(
                {
                  name: formValues.name,
                  description: formValues.description || undefined,
                  externalDescription:
                    formValues.externalDescription || undefined,
                  contact: getRoleContactFromForm(formValues.contact),
                  assignedUserIds: formValues.assignedUserIds,
                },
                currentLanguage,
              );
              await queryClient.invalidateQueries({
                queryKey: ["roles", currentLanguage],
              });
              closeModal();
            } catch {
              setHasError(true);
            } finally {
              setLoading(false);
            }
          })();
        }}
      />
    </Modal>
  );
}
